export default __webpack_public_path__ + "web/images/products/rmavc_white.svg";